import SpinRecord from "integration/revolver/schema/spin-record";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Point from "slotworks/utils/geom/point";

export default class ICFreespinRecord extends FreespinRecord {
    public retrigger: boolean = false;
    public retriggered: boolean = false;
    public freespinsWon:number = 0;

    public addedCoins: number[] = [0, 0, 0, 0, 0];
    public potsValues: number[] = [0, 0, 0, 0, 0];
    public persistedPotsValues: Map<number, number[]> = new Map();
    public potTriggeredFeatures: string[] = [];
    public isJackpotWon: boolean = false;
    public instantWin: number;
    public underCoinSymbols: Map<Point, string> = new Map();
    public bonusTriggered: boolean;
}
